var {AmpersandApp: productCatalogApp, AmpersandView} = require('catalog/libs');

var HPEConstants = require('../../../base/hpe.constants');

var template = require('../templates/hpe.productlist.filter.template.tpl');

/**
 * collection of filters
  * view hierarchy: filterlist > facet collection > facet > filtergroup collection > filter group > filter collection (this) > filter
 */
var FilterCollectionView = AmpersandView.extend({
    initialize: function(options) {
        //save passed parentId to propegate to children
        if (options.parentId) {
            this.parentId = options.parentId;
        }
    },

    render: function(opts) {
        var that = this;
        this.renderCollection(this.collection, function(options) {
            return new FilterView(options, that.parentId);
        }, this.el, opts);
        return this;
    }
});

/**
 * filter view
 * view hierarchy: filterlist > facet collection > facet > filtergroup collection > filter group > filter collection > filter (this)
 */
var FilterView = AmpersandView.extend({

    initialize: function(options, parentId) {
        if (parentId) {
            this.model.parentId = parentId;
        }
    },
    template: template,
    bindings: {
        'model.facetValue': {
            type: 'innerHTML',
            selector: '.facet-label'
        },
        'model.groupname': {
            type: 'attribute',
            selector: 'input',
            name: 'name'
        },
        'model.formatCount': {
            type: 'text',
            selector: '.facet-count'
        },
        'model.type': {
            type: 'attribute',
            selector: 'input',
            name: 'data-analytics-name'
        },
        'model.analyticsEvent': {
            type: 'attribute',
            selector: 'input',
            name: 'data-analytics-event'
        },
        'model.isChecked': [
            {
                type: function(el, value) {
                    if (value) {
                        $(el).prop('checked', true);
                    }
                },
                selector: 'input'
            },
            {
                type: 'booleanClass',
                selector: '.checkbox-input',
                name: 'active'
            },
            {
                type: 'attribute',
                selector: '.checkbox-input',
                name: 'aria-checked'
            }
        ],
        'model.domid': [
            {
                type: 'attribute',
                selector: 'input',
                name: 'id'
            },
            {
                type: 'attribute',
                selector: 'label',
                name: 'for'
            }
        ]
    },

    events: {
        'keyup .input-selectable': 'onFilterKeyUp',
        'change input': 'onCheckboxChange'
    },

    /**
     * handle key up event on checkbox
     */
    onFilterKeyUp: function(e) {

        //watch for space and return to change state of checkbox
        if ((e.keyCode === 13) || (e.keyCode === 32)) {
            this.onCheckboxChange(e);
        }
    },

    /**
     * handle checkbox input change event
     */
    onCheckboxChange: function() {

        //update model (until overwritten by XHR response)
        this.model.isChecked = !this.model.isChecked;

        //broadcast view update request
        productCatalogApp.trigger(HPEConstants.catalog.VIEW_UPDATE_REQUEST, {
            id: this.model.parentId,
            value: this.model.facetValueId,
            type: (this.model.isChecked) ? 'filteradd' : 'filterremove'
        });
    }
});

module.exports = FilterCollectionView;
